import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./shared/themes/theme";
import ConfirmationProvider from "./shared/components/confirmation/ConfirmationProvider";
import reportWebVitals from "./reportWebVitals";
import { store } from "./core/store";
import "./index.scss";
import App from "./App";
import "./core/i18n";
import I18nProvider from "./shared/components/I18nProvider";

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <I18nProvider>
          <ConfirmationProvider>
            <App />
          </ConfirmationProvider>
        </I18nProvider>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();